import { render, staticRenderFns } from "./ModalLayoutRelative.vue?vue&type=template&id=4587b974&scoped=true&"
import script from "./ModalLayoutRelative.vue?vue&type=script&lang=js&"
export * from "./ModalLayoutRelative.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayoutRelative.vue?vue&type=style&index=0&id=4587b974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587b974",
  null
  
)

export default component.exports